<template>
  <li
    class="sui-tab"
    :class="{
      'sui-tab--active': tab.value === modelValue,
      [activeTabClass]: tab.value === modelValue && activeTabClass,
      [tabClass]: tabClass,
    }"
    data-cy="tab"
  >
    <div class="sui-tab__link">
      <slot />
    </div>

    <div class="sui-tab__indicator-container">
      <div class="sui-tab__indicator"></div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { toRefs, PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: [Number, String, null] as PropType<number | string | null>,
    default: null,
  },
  tab: {
    type: Object,
    default: () => ({}),
  },
  tabClass: {
    type: String,
    default: "",
  },
  activeTabClass: {
    type: String,
    default: "",
  },
});

const { tabClass, tab, modelValue, activeTabClass } = toRefs(props);

defineEmits(["update:modelValue"]);
</script>

<style lang="scss" scoped>
.sui-tab {
  position: relative;
  height: 100%;

  &__link {
    padding: 9px 8px 0;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-text-secondary);
    cursor: pointer;
  }

  &__indicator-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: var(--color-button-disabled);
  }

  &__indicator {
    width: 100%;
    height: 100%;
    background-color: var(--color-icon-accent-dangerous);
    opacity: 0;
    transform: scale3d(0, 1, 1);
    transform-origin: center;
    transition:
      transform 0.2s ease-out,
      opacity 0.15s ease-out;
  }

  &--active {
    .sui-tab__link {
      color: var(--color-text-primary);
    }

    .sui-tab__indicator {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
}
</style>
